// extracted by mini-css-extract-plugin
module.exports = {"CompanyAddressDetails":"index-module_CompanyAddressDetails_1SaJT"};